export default "<router-outlet></router-outlet>\n<easyroute-loading></easyroute-loading>"